import { Layout } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useNavigation } from 'react-router-dom';
import { Header, SecondaryHeader } from "../header";
import Styles from './page.module.scss';
const { Content } = Layout;

function Page({ title, className, children, summary, header, backLink, footer, loading = false }) {
  const navigation = useNavigation()
  return (
    <>
      <div className={Styles.header}>
        <Header title={title} backLink={backLink} summary={summary} />
        {!!header && <SecondaryHeader content={header} backLink={false} />}

      </div>
      <Content className={`page ${className}`} style={{ opacity: loading || navigation.state === 'loading' ? 0.6 : 1 }}>
        <div className={Styles.innerWrapper}>
          <div className={Styles.contentWrapper}>
            {children}
          </div>
          <div className={Styles.footer} style={{ display: 'flex', justifyContent: 'space-between' }}>
            {footer}
          </div>
        </div>
      </Content>
    </>
  );
}


Page.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  header: PropTypes.node,
  footer: PropTypes.node,
  loading: PropTypes.bool,
  backLink: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Page;


// import { Layout, Spin } from "antd";
// import PropTypes from "prop-types";
// import React from "react";
// import { useNavigation } from 'react-router-dom';
// import { Header } from "../header";
// const { Content } = Layout;

// function Page({ title, className, children, header , canGoBack }) {
//   const navigation = useNavigation()

//   return (
//     <>
//       <Header title={title} canGoBack={canGoBack} />
//       <Content className={`page ${className}`}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse'  , margin : '12px 0px'}}>
//           {header}
//         </div>
//         {navigation.state === 'loading' ? <Spin /> : children}
//       </Content>
//     </>
//   );
// }

// Page.propTypes = {
//   className: PropTypes.string,
//   canGoBack :PropTypes.bool,
//   title: PropTypes.string.isRequired,
//   children: PropTypes.oneOfType([
//     PropTypes.arrayOf(PropTypes.node),
//     PropTypes.node,
//   ]),
//   header: PropTypes.node,
// };

// export default Page;
